import { apiFetch } from './apiClient';

export async function listarUsuarios() {
  return apiFetch('/usuarios');
}

export async function criarUsuario(dados) {
  return apiFetch('/usuarios', {
    method: 'POST',
    body: JSON.stringify(dados),
  });
}

export async function atualizarUsuario(id, dados) {
  return apiFetch(`/usuarios/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(dados),
  });
}

export async function toggleAtivoUsuario(id, ativo) {
  return apiFetch(`/usuarios/${id}/ativo`, {
    method: 'PATCH',
    body: JSON.stringify({ ativo }),
  });
}

export async function excluirUsuario(id) {
  return apiFetch(`/usuarios/${id}`, { method: 'DELETE' });
}

/* admin define uma senha nova pra um sub-usuário já existente -- não
   existia antes (a senha só era definida na criação). Necessário porque
   as senhas não foram migradas do Supabase Auth no corte. */
export async function redefinirSenhaUsuario(id, novaSenha) {
  return apiFetch(`/usuarios/${id}/senha`, {
    method: 'PATCH',
    body: JSON.stringify({ novaSenha }),
  });
}

/* Troca a pessoa que ocupa o setor mantendo o e-mail: inativa o usuário
   atual e cria o novo no mesmo e-mail, numa operação só. Renomear o
   usuário apagaria a história de quem esteve ali antes. */
export async function sucederUsuario(id, { nome, senha, tipo, setor }) {
  return apiFetch(`/usuarios/${id}/suceder`, {
    method: 'POST',
    body: JSON.stringify({ nome, senha, tipo, setor }),
  });
}
